import React, { Suspense, useEffect, useState } from 'react';
import { AppHeader } from './Componets/Components';
import { Spinner } from '../../components/Ui/EiedUi'
import { apiFactory } from "services/ApiFactory";
import {
    Modal,
    ModalHeader,
    ModalBody,
    Row,
    Col,
    Button
  } from "reactstrap";
import UseGetUserAccessDetail from 'hocs/UseGetUserAccessDetail'
import './styles/SecondLayout.scss';
import ProfileSecurity from './ProfileSecurity'
import { applicationsRole } from 'utils/permissionConstants'
import useTheme from "hooks/useTheme";
import { handleNullArray, isObjectNull } from 'utils/utils';


const LayoutHeader = React.lazy(() => import('./SecondHeader'));
const LayoutFooter = React.lazy(() => import('./SecondFooter'));
const LayoutAside = React.lazy(() => import('./SecondAside'));
const LayoutSideBar = React.lazy(() => import('./SecondSideBar'));
const LayoutSecondMain = React.lazy(() => import('./SecondMain'));


export function SecondLayout(props) {
    var currentUser = apiFactory.intranetApiFactory.generalInformation.getPresentUserGeneralInfo();
    const userPermissionAccessor =  UseGetUserAccessDetail();
    const [modal, setModal] = useState(false);
    const [page, setPage] = useState('/');
    const [loading, setLoading] = useState(false);
    const themeInformation = useTheme();
    const [sidebarAccessDenied, setSidebarAccessDenied] = useState(false);


    useEffect(() => {
        const setSidebarAccess = async () => {
            let resultItems = (apiFactory.intranetApiFactory.userAuthorization.getUserApplicationPermission()).roleMembers;
            let hasEmployeePermission = handleNullArray(resultItems).find(cond => cond.role.id === applicationsRole.general.employee || cond.role.id === applicationsRole.general.apprentice);

            if (isObjectNull(hasEmployeePermission)) {
                setSidebarAccessDenied(true);
            }     
        }

        setSidebarAccess();
    }, [])

    const toggle = async () => {
        if (modal) {
            apiFactory.intranetApiFactory.profileSecurity
            .remove(currentUser.userId)
            .then((response) => {
            })
            .catch((err) => {});
        }

        setModal(!modal);
    }


    function onItemClickHandler(e, page) {
        e.preventDefault();
        if (page.toString().trim().toLowerCase().includes("profile")) {
            setPage(page);
            toggle();
        } else {
          props.history.push(page);
        }
    }


    return (
        <div className={`app ${props.themeClass}`}>
            {/* <Row> */}
                {/* <Col xs={12} sm={12} md={12} lg={12}> */}
                    <AppHeader fixed className={`app-theme-${themeInformation.theme} app-header`}  style={{ alignItem: "center", justifyContent: "space-between"}}>
                        <Suspense fallback={<Spinner />} >
                            <LayoutHeader setLoading={setLoading}  {...props} onItemClickHandler={(e, page) => onItemClickHandler(e, page)} />
                        </Suspense>
                    </AppHeader>
                {/* </Col> */}
            {/* </Row> */}
            <div className="app-body">
                { sidebarAccessDenied === true ? null : <LayoutSideBar {...props} />}                
                <main className="main">
                    {loading && <Spinner />}
                    <LayoutSecondMain {...props} />
                </main>
                { sidebarAccessDenied === true ? null : <LayoutAside {...props} />}              
            </div>
            <LayoutFooter />
            <Modal isOpen={modal} toggle={toggle} style={{maxWidth: "20vw"}}>
                <ModalHeader className={`app-theme-${themeInformation.theme} modal-header`} toggle={toggle}>اعتبار سنجی</ModalHeader>
                <ModalBody className={`app-theme-${themeInformation.theme} modal-body`}style={{paddingBottom: "5px"}}>
                    <ProfileSecurity history={props.history} page={page} onClose={toggle} />
                </ModalBody>
            </Modal>            
        </div>
    );

}